import { Box, CircularProgress, Typography } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import I18n from 'i18n-js'
import { useContext, useEffect, useState } from 'react'
import { SnackBar } from '../../components'
import CardMap from '../../components/cardMap'
import SearchBar from '../../components/searchBar'
import { AuthContext } from '../../context/auth'
import medicalsCenter from '../../services/medicalsCenter'
import { generateStatisticReport } from './components/hooks/generateStatisticReport'
import { useStatisticReportModalController } from './components/hooks/StatisticReportModalController'
import { StatisticReport } from './components/StatisticReport'
import useStyles from './style'

const Home = () => {
  const { state } = useContext(AuthContext)
  const [data, setData] = useState()
  const [centers, setCenters] = useState([])
  const [pagination, setPagination] = useState(0)
  const [page, setPage] = useState(0)
  const [message, setMessage] = useState({ text: '', variant: 'success', open: false })
  const cardsPerPage = 9
  const numberOfPages = Math.ceil(centers.length / 9)
  const statisticReportController = useStatisticReportModalController()

  const getData = async () => {
    const res = await medicalsCenter.list()
    setData(res.data?.medicalCenters || [])
    setCenters(res.data?.medicalCenters || [])
  }

  const getIndicatorByMedicalCenter = async () => {
    const success = await generateStatisticReport(statisticReportController, state)
    setMessage({
      open: true,
      text: I18n.t(success ? "general.statisticSnackbar.success" : "general.statisticSnackbar.error"),
      variant: success ? 'success' : 'warning',
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const handleChangeSearch = (e) => {
    if (e.target.value) {
      const results = data.filter((dat) =>
        dat.name.toLowerCase().includes(e.target.value.trim().toLowerCase())
      )
      setCenters(results)
      setPagination(0)
    } else {
      setCenters(data)
      setPagination(page)
    }
  }
  const handleChangePagination = (e, value) => {
    setPagination(value - 1)
    setPage(value - 1)
  }

  const handleSnackbar = () => {
    setMessage({ open: false })
  }
  const classes = useStyles()

  return (
    <div>
      <Box px={4} className={classes.container}>
        <Box my={4} className={classes.headContainer}>
          <Typography variant="h4" color="primary">{I18n.t('sidebar.mcenter')}</Typography>

          <div className={classes.searchBar}>
            <StatisticReport {...statisticReportController} handleSave={getIndicatorByMedicalCenter} />

            <SearchBar change={handleChangeSearch} />
          </div>
        </Box>
        <div className={classes.cardConatiner}>
          {centers.length > 0 &&
            centers
              .slice(
                pagination * cardsPerPage,
                pagination * cardsPerPage + cardsPerPage
              )
              .map((center, index) => {
                return (
                  <CardMap
                    addCheck={statisticReportController.access}
                    key={index}
                    center={center}
                    data={data}
                    checked={statisticReportController.data.selected.includes(center.id)}
                    onCheckedChange={(_, data) => {
                      statisticReportController.handleSelect({ id: data?.id })
                    }}
                  />
                )
              })}
        </div>
        {data ? (
          centers.length > 1 && (
            <div className={classes.pagination}>
              <Pagination
                shape="rounded"
                count={numberOfPages}
                onChange={handleChangePagination}
                id="pagination"
              />
            </div>
          )
        ) : (
          <CircularProgress className={classes.circularProgress} />
        )}
      </Box>


      <SnackBar
        text={message.text}
        severity={message.variant}
        show={message.open}
        HandleShow={handleSnackbar}
        time={1500}
      />
    </div>
  )
}

export default Home
